module.exports = __webpack_public_path__ + "static/img/zmlogo.44246950.png";